import {
  getCollectDatas,
  subReferrerDatas
} from '@/services/config'
export default {
  namespaced: true,
  state: {
    submitting: false,
    datasReady: false,
    datas: [],
    form: '',
    isBtnDisable: false,
    isCofigFormEdit: false,
    decorators: {
    },
    receptionDatas: {}
  },
  mutations: {
    // 设置数据容器的值
    setDatas (state, datas) {
      state.datas = datas
      state.datasReady = true
    },
    setReceptionDatas (state, datas) {
      state.receptionDatas = datas
    },
    setSubmitting (state, type) {
      state.submitting = type
    },
    setForm (state, form) {
      state.form = form
    },
    setIsEdit (state, b) {
      state.isCofigFormEdit = b
    },
    setBtnDisable (state, b) {
      state.isBtnDisable = b
    }
  },
  actions: {
    async fetchReceptionDatas ({ commit, state }, params = {}) {
      const chain = await getCollectDatas()
      chain.params(params)
        .config({ tip: false })
        .onSuccess((raw) => {
          commit('setReceptionDatas', raw)
        })
        .fetch()
      return chain
    },
    async fetchReferrerDatas ({ commit, state }) {
      commit('setSubmitting', true)
      const chain = await getCollectDatas()
        .onSuccess((raw) => {
          commit('setDatas', raw)
        })
        .onNetComplete(() => {
          commit('setSubmitting', false)
        })
        .config({ tip: false })
      return chain
    },
    async subReferrer ({ commit, dispatch }) {
      commit('setSubmitting', true)
      const chain = await subReferrerDatas()
        .onSuccess(async () => {
          // const res = await dispatch('fetchCollectDatas', type)
          // res.fetch()
        })
        .onNetComplete(() => {
          commit('setSubmitting', false)
        })
        .config({ tip: false })
      return chain
    },
    addClick () {
      window.onbeforeunload = function (e) {
        return false
      }
    },
    removeClick () {
      window.onbeforeunload = null
    }

  }
}
